var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContent',{attrs:{"title":"Editar pack de eventos"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h3',[_vm._v("Datos del pack")])]},proxy:true},{key:"content",fn:function(){return [(_vm.pack)?_c('Form',{attrs:{"data":_vm.pack},on:{"terminado":function($event){return _vm.editarPack()}}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }